import { Concierge } from '@/types/concierge'
import { createContext, useContext } from 'react'

interface ConciergeContextType {
  concierge: Concierge
  updateConcierge: (updates: Partial<Concierge>) => Promise<void>
}

export const ConciergeContext = createContext<ConciergeContextType>({
  concierge: {} as Concierge,
  updateConcierge: async () => {},
})

export function useConcierge() {
  const context = useContext(ConciergeContext)
  if (context === undefined) {
    throw new Error('useConcierge must be used within a ConciergeProvider')
  }
  return context
}
